import { generateInteractionProps } from "@/utils/generate-smart-toilets-interactions"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const handleProductListHeroCTAClick = (evt, ctaText) => {
  const interactionData = generateInteractionProps(ctaText, {
    internalLinkName: ctaText,
    internalLinkPosition: "pxp:shop smart toilets",
    internalLinkType: `pxp:${ctaText}`,
  })

  pushAnalyticsObjToDataLayer({ ...interactionData })
}

export const handleProductListHeroImageClick = title => {
  const interactionData = generateInteractionProps(title, {
    internalLinkName: title,
    internalLinkPosition: "pxp:shop smart toilets",
    internalLinkType: `pxp:${title}`,
  })

  pushAnalyticsObjToDataLayer({ ...interactionData })
}
